import Box from '@mui/material/Box';
import { Modal, ModalProps } from '@mui/material';
import { SystemStyleObject, Theme } from '@mui/system';
import React, { ReactElement } from 'react';

// Default modal configuration
const configModalDefault: object = {
    open: false, // Set default open value
    onClose: () => { }, // Default no-op function for onClose
    "aria-labelledby": "modal-modal-title",
    "aria-describedby": "modal-modal-description"
};


// Default modal box style configuration
const styleBoxDefault: SystemStyleObject<Theme> = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    px: 2,
    pt: 2,
    pb: 4,
    borderRadius: 2
};

// ModalElementProps now extends both ModalProps and ModalOwnProps
interface ModalElementProps extends ModalProps {
    styleBox?: SystemStyleObject<Theme>; // Custom style for Box
    children: ReactElement; // Allow any valid ReactNode (multiple children or single element)
}

const ModalElement: React.FC<ModalElementProps> = ({ styleBox, children, ...props }) => {
    const configModal = { ...configModalDefault, ...props }
    const configStyleBox = { ...styleBoxDefault, ...styleBox }
    return (
        <Modal {...configModal}>
            <Box sx={configStyleBox}>
                {children}
            </Box>
        </Modal>
    );
};

// Default props for ModalElement
ModalElement.defaultProps = {
    styleBox: styleBoxDefault,
};

export default ModalElement;
